import GeoJSON from 'ol/format/GeoJSON'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import { Stroke, Style } from 'ol/style'

export const DISTRICT_LAYER_ID = 'gis-district-outline'

/** Stroke-only outline: the interior stays hit-testable for mandal clicks. */
export async function buildDistrictOutlineLayer(geojsonUrl: string): Promise<VectorLayer<VectorSource>> {
  const res = await fetch(geojsonUrl)
  if (!res.ok) {
    throw new Error(`Failed to load ${geojsonUrl}: ${res.status}`)
  }
  const geojson: unknown = await res.json()
  const source = new VectorSource({
    features: new GeoJSON().readFeatures(geojson, {
      dataProjection: 'EPSG:4326',
      featureProjection: 'EPSG:3857',
    }),
  })
  const layer = new VectorLayer({
    source,
    zIndex: 6,
    style: new Style({ stroke: new Stroke({ color: 'rgba(15,23,42,0.85)', width: 2.5 }) }),
  })
  layer.set('id', DISTRICT_LAYER_ID)
  return layer
}
